import { Button, Col, Input, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CustomerForm.css";
import axios from "axios";
import { url } from "../../constant/url";
import { LeftOutlined } from "@ant-design/icons";

function CustomerForm({ history, match }) {
  const [data, setData] = useState({
    code: "",
    name: "",
    alias: "",
    phone: "",
    email: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    if (match.params.id) {
      getData();
    }
  }, []);

  const handleChange = (name, value) => {
    setErrors({
      ...errors,
      [name]: "",
    });

    setData({
      ...data,
      [name]: value,
    });
  };

  const getData = () => {
    setLoading(true);
    axios
      .get(`${url}/customer/${match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        const { code, name, alias, phone, email, address } = res.data.data;
        setData({
          ...data,
          code,
          name,
          alias,
          phone,
          email,
          address,
        });
        console.log(res);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReset = () => {
    setData({
      code: "",
      phone: "",
      alias: "",
      name: "",
      email: "",
      address: "",
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        match.params.id
          ? `${url}/customer/${match.params.id}`
          : `${url}/customer`,
        {
          code: data.code,
          name: data.name,
          alias: data.alias,
          email: data.email,
          phone: data.phone,
          address: data.address,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        message.success(res.data.message);
        history.push("/customer");
      })
      .catch((err) => {
        if (err.response) {
          setErrors(err.response.data.errors);
          message.error(err.response.data.message);
        }
        setLoading(false);
      });
  };

  console.log(errors);

  return (
    <div>
      <ul className="breadcumb">
        <li>
          <Link to="/customer">
            <LeftOutlined />
            Customer
          </Link>
        </li>
        <li className="active">
          {match.params.id ? "Edit Customer" : "Add Customer"}
        </li>
      </ul>
      <div className="content">
        <form onSubmit={handleSave}>
          <Row gutter={20}>
            <Col md={18} xs={24}>
              <div className="form-group">
                <label className="form-label">
                  Code <span className="error-text">*</span>
                </label>
                <Input
                  value={data.code}
                  className={errors && errors.code ? "is-error" : ""}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
                {errors && errors.name && (
                  <span className="error-text">{errors.code[0]}</span>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Name
                </label>
                <Input
                  value={data.name}
                  className={errors && errors.name ? "is-error" : ""}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
                {errors && errors.name && (
                  <span className="error-text">{errors.name[0]}</span>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Alias <span className="error-text">*</span>
                </label>
                <Input
                  value={data.alias}
                  className={errors && errors.alias ? "is-error" : ""}
                  onChange={(e) => handleChange("alias", e.target.value)}
                />
                {errors && errors.alias && (
                  <span className="error-text">{errors.alias[0]}</span>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Phone
                </label>
                <Input
                  value={data.phone}
                  className={errors && errors.phone ? "is-error" : ""}
                  onChange={(e) => handleChange("phone", e.target.value)}
                />
                {errors && errors.phone && (
                  <span className="error-text">{errors.phone[0]}</span>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">
                  Email
                </label>
                <Input
                  value={data.email}
                  className={errors && errors.email ? "is-error" : ""}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
                {errors && errors.email && (
                  <span className="error-text">{errors.email[0]}</span>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Address
                </label>
                <Input.TextArea
                  rows={6}
                  value={data.address}
                  className={errors && errors.address ? "is-error" : ""}
                  onChange={(e) => handleChange("address", e.target.value)}
                />
                {errors && errors.address && (
                  <span className="error-text">{errors.address[0]}</span>
                )}
              </div>

              <div className="form-group">
                <Button
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                  style={{ backgroundColor: "#1b2086", borderColor: "#1b2086" }}
                >
                  {/* <i className="mdi mdi-content-save mr-5" />  */}
                  Submit
                </Button>

                <Button
                  htmlType="reset"
                  type="primary"
                  onClick={handleReset}
                  // loading={loading}
                  style={{
                    backgroundColor: "#1b2086",
                    marginLeft: 10,
                    borderColor: "#1b2086",
                  }}
                >
                  {/* <i className="mdi mdi-content-save mr-5" /> */}
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );
}

export default CustomerForm;
